import { CommodityIntelegenceTowerTypes } from "./commodity-intelegence-tower.types";

export const setScreen = (data) => {
  return {
    type: CommodityIntelegenceTowerTypes.SET_SCREEN,
    payload: data,
  };
};

export const setCitData = (data) => {
  return {
    type: CommodityIntelegenceTowerTypes.SET_CIT_DATA,
    payload: data,
  };
};

export const setPowerbiData = (data) => {
  return {
    type: CommodityIntelegenceTowerTypes.SET_POWERBI_DATA,
    payload: data,
  };
};
